this.gmak = null
this.initialized = false
this.callbacks = []
this.google = null

export const setGmak = gmak => {
    this.gmak = gmak
}

export const initMap = callback => {
    if(this.google) {
        callback(this.google)
        return
    } else {
        if(!this.callbacks)
            this.callbacks = []
    
        this.callbacks.push(callback)
    }

    window.initMap = () => {
        this.google = window.google
        this.callbacks.forEach(callback => {
            callback(this.google)
        })
    }

    if(!this.initialized) {
        const script = document.createElement("script")
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.gmak}&libraries=places&callback=initMap`
        script.async = true
        document.body.appendChild(script)
        this.initialized = true
    }
}

export const findAddress = address => {
    let geocoder = new this.google.maps.Geocoder()    
    var googleStatus = this.google.maps.GeocoderStatus.OK;
    return new Promise((resolve, reject) => {
        
        geocoder.geocode({ 'address' : address }, function( results, status ) {
            if( status === googleStatus ) {
                let address = {}
                address.lat = results[0].geometry.location.lat()
                address.lng = results[0].geometry.location.lng()
                resolve(address)
            } else {
                reject(status)
            }
        })
    })
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/third-party/Gmaps/Core.js